import {useMutation, useQuery} from 'react-query'
import {useParams} from 'react-router-dom'

import {SubscriptionsMutations, SubscriptionsQueries} from './index'
import {PaySubscriptionByOneTimePaymentMuOp} from './mutations/create-subscription-for-pay'
import {PaySubscriptionByTokenMuOp} from './mutations/pay-subscription-by-token.mutation'
import {GetSubscriptionQueryParams} from './queries/get-subscription-entity'

export const useSubscription = (id?: string, query?: GetSubscriptionQueryParams) => {
  const {subscriptionId} = useParams()
  const idToUse = id || subscriptionId

  return useQuery(SubscriptionsQueries.getSubscriptionQuery({
    params: idToUse,
    query,
    refetchOnWindowFocus: false,
  }))
}

export const useCreateSubscriptionRequest = (id: string) => {
  return useMutation(
    SubscriptionsQueries.createSubscriptionRequestMutation({
      params: {
        subscriptionId: id,
      },
    }),
  )
}

export const useBuySubscriptionByToken = (params?: PaySubscriptionByTokenMuOp) =>
  useMutation(SubscriptionsMutations.paySubscriptionByTokenMutation(params))

export const useBuySubscriptionByOneTimePayment = (params?: PaySubscriptionByOneTimePaymentMuOp) =>
  useMutation(SubscriptionsMutations.paySubscriptionByOneTimePayment(params))
